"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _api = require("../../api");
var _response = require("../../utils/response");
var _subscription = require("../../api/accessors/subscription");
var _plan = require("../../api/accessors/plan");
var _SubscriptionPlansRadioGroup = require("../SubscriptionPlansRadioGroup");
var _Translated = _interopRequireDefault(require("../Translated"));
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SubscriptionForm = _ref => {
  let {
    onCancel,
    onSubmit,
    onSuccess,
    subscription,
    plan: initialPlan = null,
    maxWidth = 400,
    submitButtonClass,
    submitButtonProps = {},
    onPlanChange = () => {},
    buttonsContainerProps = {},
    apiFetchPlans: passedApiFetchPlans,
    cancelButtonText = /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "cancel"
    }),
    submitButtonText = /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "subscribe"
    }),
    noMargins = false,
    showTotalPrice: isTotalPriceShown = true
  } = _ref;
  const editMode = !!subscription;
  const [selectedPlan, setSelectedPlan] = (0, _react.useState)(editMode ? (0, _subscription.getPlan)(subscription) : initialPlan);
  const planId = (0, _plan.getId)(selectedPlan);
  const [requestError, setRequestError] = (0, _react.useState)(null);
  const [requestInProgress, setRequestInProgress] = (0, _react.useState)(false);
  const [isSinglePlanAvailable, setSinglePlanAvailable] = (0, _react.useState)(false);
  const withMargins = !noMargins && !isSinglePlanAvailable;
  const subscriptionRequest = async () => {
    setRequestError(null);
    setRequestInProgress(true);
    const apiRequest = editMode ? _api.updateSubscription : _api.createSubscription;
    const itemToUpdate = subscription && subscription.items.data.find(item => item.plan && item.plan.id === (0, _plan.getId)((0, _subscription.getPlan)(subscription)));
    const requestData = !editMode ? [{
      items: [{
        plan: planId
      }]
    }] : [(0, _subscription.getId)(subscription), {
      items: [{
        id: itemToUpdate.id,
        plan: planId
      }]
    }];
    const [error, response] = await apiRequest(...requestData);
    if (!error && response) {
      onSuccess(response);
    } else {
      setRequestError(error);
    }
    setRequestInProgress(false);
  };
  const onFormSubmit = e => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(e);
    } else {
      subscriptionRequest();
    }
  };
  const handlePlanChange = plan => {
    setSelectedPlan(plan);
    onPlanChange(plan);
  };
  const handlePlansReceived = plans => {
    setSinglePlanAvailable(plans.length === 1);
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    maxWidth: maxWidth,
    flexDirection: "column"
  }, requestError && !(0, _response.getValidationErrors)(requestError) && /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    minContent: true,
    text: (0, _response.getErrorMessage)(requestError)
  }), /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: onFormSubmit
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mx: withMargins ? 7 : 0
  }, /*#__PURE__*/_react.default.createElement(_SubscriptionPlansRadioGroup.SubscriptionPlansRadioGroup, {
    defaultSelectedPlan: selectedPlan,
    onPlanChange: handlePlanChange,
    fetchPlans: passedApiFetchPlans,
    maxWidth: maxWidth,
    onPlansReceived: handlePlansReceived,
    disabled: requestInProgress,
    showTotalPrice: isTotalPriceShown
  })), /*#__PURE__*/_react.default.createElement(_core.FormHelperText, null, (0, _response.getValidationErrorMessage)(requestError, 'items.0.plan')), /*#__PURE__*/_react.default.createElement(_core.Box, _extends({
    display: "flex"
  }, buttonsContainerProps), onCancel && /*#__PURE__*/_react.default.createElement(_core.Box, {
    marginRight: 2,
    display: "inline"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: onCancel,
    variant: "contained",
    disabled: requestInProgress,
    "data-testid": "cancel-button"
  }, cancelButtonText)), /*#__PURE__*/_react.default.createElement(_core.Button, _extends({
    type: "submit",
    color: "primary",
    variant: "contained",
    disabled: requestInProgress,
    className: submitButtonClass
  }, submitButtonProps, {
    "data-testid": "submit-button"
  }), submitButtonText))));
};
exports.SubscriptionForm = SubscriptionForm;